<template>
  <div>
    <div class="about_pc">
      <div class="home_tit" style="color: #ffffff">我们已经做到</div>
      <div class="home_con">
        <div class="about_con">
          <ul>
            <li>
              <p>
                <img src="@/assets/pc/up.png" alt="" />
                <!-- <span>276</span> -->
                <span>{{ this.aboutList.allCompanyCount }}</span>
              </p>
              <p>合作伙伴(家)</p>
            </li>
            <li>
              <p>
                <img src="@/assets/pc/up.png" alt="" />
                <!-- <span>56650</span> -->
                <span>{{ this.aboutList.allPileCount }}</span>
              </p>
              <p>终端设备(台)</p>
            </li>
            <li>
              <p>
                <img src="@/assets/pc/up.png" alt="" />
                <!-- <span>26778240.72</span> -->
                <span>{{ this.aboutList.chargeQuantityCount }}</span>
              </p>
              <p>自建场站累计充电(度)</p>
            </li>
            <li>
              <p>
                <img src="@/assets/pc/up.png" alt="" />
                <!-- <span>271525091.25</span> -->
                <span>{{ this.aboutList.chargeQuantityNum }}</span>
              </p>
              <p>合作场站累计充电(度)</p>
            </li>
            <li>
              <p>
                <img src="@/assets/pc/up.png" alt="" />
                <!-- <span>602</span> -->
                <span>{{ this.aboutList.allStationCount }}</span>
              </p>
              <p>覆盖城市(个)</p>
            </li>
            <li>
              <p>
                <img src="@/assets/pc/up.png" alt="" />
                <!-- <span>304932</span> -->
                <span>{{ this.aboutList.reductionScoreCount }}</span>
              </p>
              <p>碳减排(吨)</p>
            </li>
          </ul>
        </div>
      </div>
      <img
        src="https://www.bjecpower.com/img/gw/dl.png"
        alt=""
        class="zhouImg"
      />
    </div>
    <div class="home_con">
      <div class="about_index">
        <div class="home_tit_mo" style="color: #ffffff">我们已经做到</div>
        <div class="about_con">
          <ul>
            <li>
              <p>{{ this.aboutList.allCompanyCount }}</p>
              <!-- <p>276</p> -->
              <span>合作伙伴(家)</span>
            </li>
            <li>
              <p>{{ this.aboutList.allPileCount }}</p>
              <!-- <p>56650</p> -->
              <span>终端设备(台)</span>
            </li>
            <li>
              <!-- <p>602</p> -->
              <p>{{ this.aboutList.allStationCount }}</p>
              <span>覆盖城市(个)</span>
            </li>
            <li>
              <!-- <p>304932</p> -->
              <p>{{ this.aboutList.reductionScoreCount }}</p>
              <span>碳减排(吨)</span>
            </li>
            <li>
              <!-- <p>26778240.72</p> -->
              <p>{{ this.aboutList.chargeQuantityCount }}</p>
              <span>自建场站累计充电(度)</span>
            </li>
            <li>
              <!-- <p>271525091.25</p> -->
              <p>{{ this.aboutList.chargeQuantityNum }}</p>
              <span>合作场站累计充电(度)</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      aboutList: "",
    };
  },
  created() {
    console.log(12);

    this.$axios
      .post("https://www.bjecpower.com/ecp/dt/sys/data/getData")
      .then((res) => {
        console.log(res)
        this.aboutList = res.data.map;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style scoped>
.home_tit {
  width: 100%;
  font-size: 32px;
  color: #191c27;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  text-align: center;
  line-height:38px;
}
.about_index {
  display: none;
}
.about_pc {
  width: 100%;
  height: 367px;
  /* background-image: url('https://www.bjecpower.com/camera/company/we.png');
    background-size: 100% 100%; */
}
.about_con {
  display: flex;
}
.about_con ul {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  position:relative;
  /* justify-content: space-around; */
}
.about_con ul li:nth-child(1){
  margin-left:3%;
}
.about_con ul li:nth-child(2){
  margin-left:5%;
}
.about_con ul li:nth-child(3){
  margin-left:6%;
}
.about_con ul li:nth-child(4){
  margin-left:5%;
}
.about_con ul li:nth-child(5){
  margin-left:5%;
}
.about_con ul li:nth-child(6){
  margin-left:4%;
  /* position:absolute;
  top:0;
  left:87%; */
}



/* .about_con ul li{
      width:20%;
  } */
.about_con li p:nth-child(1) {
  display: flex;
  align-items: center;
}
.about_con li span {
  font-size: 24px;
  font-family: Arial-BoldMT, Arial;
  font-weight: normal;
  margin-left: 6px;
  color: #ffffff;
  line-height: 28px;
}
.about_con li img {
  width: 14px;
  height: 13px;
}
.about_con li p:nth-child(2) {
  font-size: 14px;

  font-weight: 400;
  color: #ffffff;
  line-height: 21px;
}
.zhouImg {
  width: 874px;
  height: 11px;
  margin-top: 32px;
}
@media screen and (max-width: 1440px) {
}
@media screen and (max-width: 768px) {
  .about_pc {
    display: none;
  }
  .about_con ul li:nth-child(1){
  margin-left:0%;
}
.about_con ul li:nth-child(2){
  margin-left:0%;
}
.about_con ul li:nth-child(3){
  margin-left:0%;
}
.about_con ul li:nth-child(4){
  margin-left:0%;
}
.about_con ul li:nth-child(5){
  margin-left:0%;
}
.about_con ul li:nth-child(6){
  margin-left:0%;
 
}
  .home_tit_mo {
    font-size: 22px!important;
  font-family: PingFang-SC-Bold,PingFang-SC!important;
  font-weight: 700;
  color: #191c27;
  text-align: center;
  padding: 50px 0px 12px 0px;
    
  }
  .zhouImg {
    display: none;
  }
  .about_index {
    background-image: url(https://www.bjecpower.com/camera/company/we.png);
    width: 100%;
    height: 322px;
    background-size: 100% 100%;
    display: block;
  }
  .about_con ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-left: 30px;
  }
  .about_con ul li:nth-child(1),
  .about_con ul li:nth-child(2) {
    margin-top: 8px;
  }
  .about_con ul li {
    width: 50%;
    text-align: left;
    margin-top: 24px;
  }
  .about_con ul li p {
    font-size: 19px;
    font-weight: bold;
    color: #ffffff;
    line-height: 20px;
    font-family: PingFang-SC-Bold, PingFang-SC;
  }
  .about_con li p:nth-child(1) {
    display: flex;
    align-items: center;
    margin-left: 6px;
  }
  .about_con ul li span {
    font-size: 11px;
    display: block;
    font-weight: 400;
    color: #ffffff;
    line-height: 12px;
    margin-top: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/about.vue